<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>成就配置</span>
        </div>

        <el-form ref="formData" :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="等级">
              <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级" />
            </el-form-item>
            <el-form-item label="奖励配置">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="dialogFormVisible[index].visible = true" />
              <el-dialog :before-close="(v)=>{return handleClose(v, index)}" style="overflow-y: auto" title="奖励配置" width="600px" :visible="dialogFormVisible[index].visible">
                <el-row v-for="(r, i) in item.reward" :key="i">
                  <el-form-item label="奖励类型" style="margin-top: 10px;">
                    <el-select v-model.number="r.type" style="width: 100px" placeholder="请选择">
                      <el-option
                        v-for="(item, index) in rewardType"
                        :key="index"
                        :label="item"
                        :value="index"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="奖励数量" style="margin-top:10px;">
                    <el-input v-model.number="r.num" style="width: 180px;" placeholder="奖励数量" />
                  </el-form-item>
                  <el-form-item style="margin-top: 10px;">
                    <el-button v-if="formData[index].reward.length > 1" type="danger" @click="removeEvent(index, i)">删除</el-button>
                  </el-form-item>
                </el-row>
                <el-form-item style="margin-top: 10px;">
                  <el-button type="primary" @click="addEvent(index)">+</el-button>
                </el-form-item>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogFormVisible[index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogFormVisible[index].visible = false">确 定</el-button>
                </div>
              </el-dialog>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:achi:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-if="formData.length > 0" v-permisaction="['config:achi:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCfg, updateCfg } from '@/api/config/achi-cfg'
import { getRewardType } from '@/api/config/slot'
export default {
  name: 'AchiConfig',
  data() {
    return {
      total: 0,
      rewardType: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      dialogFormVisible: [{ 'visible': false }],
      formData: [
        {
          'levelId': 0,
          'reward': [{
            'type': 0,
            'num': 0
          }, {
            'type': 0,
            'num': 0
          }]
        }
      ]
    }
  },
  created() {
    this.getTables()
    this.getRewardTypeData()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCfg(this.queryParams).then(res => {
        res.data.list.forEach((item) => {
          this.dialogFormVisible.push({ 'visible': false })
        })
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    add() {
      this.formData.push({
        'levelId': 0,
        'reward': [{
          'type': 0,
          'num': 0
        }]
      })
      this.dialogFormVisible.push({ 'visible': false })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          this.rewardType = res.data
        }
      })
    },
    addEvent(index) {
      this.formData[index].reward.push({
        'type': 0,
        'num': 0
      })
    },
    removeEvent(index, key) {
      this.formData[index].reward = this.formData[index].reward.filter((item, k) => {
        return k !== key
      })
    },
    handleClose(done, index) {
      this.dialogFormVisible[index].visible = false
    }
  }
}
</script>

<style scoped>
</style>
